import { DependencyList, EffectCallback, useEffect } from 'react'

// due to some reason, we want to run the effect in the next tick
export const useNextEffect = (effect: EffectCallback, deps?: DependencyList | undefined) => {
  return useEffect(() => {
    setTimeout(() => {
      effect()
    }, 0)
  }, deps)
}
